var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { faBars } from "@fortawesome/pro-regular-svg-icons";
import { faUndo } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Checkbox, Divider, Icon, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { Icons } from "../../assets";
import { ColorConfigs, LabelConfigs } from "../../configurations";
var ColumnSetting = function (_a) {
    var orderedColumns = _a.columns, selectedColumnKeys = _a.selectedColumnKeys, fixedColumns = _a.fixedColumns, size = _a.size, defaultColumnKeys = _a.defaultColumnKeys, shouldFixFirstColumn = _a.shouldFixFirstColumn, onRevert = _a.onRevert, onChange = _a.onChange;
    var _b = useState(shouldFixFirstColumn ? orderedColumns.slice(1, orderedColumns.length) : orderedColumns), newOrderedColumns = _b[0], setNewOrderedColumns = _b[1];
    var _c = useState(size), newSize = _c[0], setNewSize = _c[1];
    var _d = useState(selectedColumnKeys), newSelectedColumnKeys = _d[0], setNewSelectedColumnKeys = _d[1];
    useEffect(function () {
        if (newOrderedColumns !== orderedColumns) {
            setNewOrderedColumns(shouldFixFirstColumn ? orderedColumns.slice(1, orderedColumns.length) : orderedColumns);
        }
    }, [orderedColumns]);
    useEffect(function () {
        if (newSize !== size) {
            setNewSize(size);
        }
    }, [size]);
    useEffect(function () {
        if (newSelectedColumnKeys !== selectedColumnKeys) {
            setNewSelectedColumnKeys(selectedColumnKeys);
        }
    }, [selectedColumnKeys]);
    var onColumnOrderChange = function (columKeys, result) {
        var updatedNewOrderedColumns = [];
        columKeys.forEach(function (columnKey) {
            var matched = newOrderedColumns.find(function (column) { return column.key === columnKey; });
            if (matched) {
                updatedNewOrderedColumns.push(matched);
            }
        });
        setNewOrderedColumns(updatedNewOrderedColumns);
    };
    var onToggleColumn = function (key) {
        var updatedSelectedColumnKeys = __spreadArray([], newSelectedColumnKeys, true);
        if (updatedSelectedColumnKeys.includes(key)) {
            updatedSelectedColumnKeys = updatedSelectedColumnKeys.filter(function (column) { return column !== key; });
        }
        else {
            updatedSelectedColumnKeys.push(key);
        }
        setNewSelectedColumnKeys(updatedSelectedColumnKeys);
    };
    //if column preference is dragged
    var onDragEnd = function (result) {
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        var updatedOrderedColumnsKey = newOrderedColumns.map(function (column) { return column.key.toString(); });
        var removed = updatedOrderedColumnsKey.splice(result.source.index, 1)[0];
        updatedOrderedColumnsKey.splice(result.destination.index, 0, removed);
        onColumnOrderChange(updatedOrderedColumnsKey, result);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "padding-top-sm padding-left-sm padding-right-sm", style: { height: '380px', overflow: "scroll" } },
            React.createElement("div", null,
                React.createElement(Typography.Text, { type: "secondary", className: "label-2", strong: true }, LabelConfigs.DISPLAY_DENSITY.toUpperCase()),
                React.createElement("br", null),
                React.createElement("div", { className: "margin-top-xs" },
                    React.createElement(Icon, { className: "cursor-pointer ".concat(newSize !== "default" ? "color-gray-4" : ""), style: { cursor: "pointer" }, onClick: function () { return setNewSize("default"); }, component: function () { return React.createElement(Icons.LowDensity, null); } }),
                    React.createElement(Icon, { className: "cursor-pointer margin-sm-horizontal ".concat(newSize !== "middle" ? "color-gray-4" : ""), onClick: function () { return setNewSize("middle"); }, component: function () { return React.createElement(Icons.MediumDensity, null); } }),
                    React.createElement(Icon, { className: "cursor-pointer ".concat(newSize !== "small" ? "color-gray-4" : ""), style: { cursor: "pointer" }, onClick: function () { return setNewSize("small"); }, component: function () { return React.createElement(Icons.HighDensity, null); } }))),
            React.createElement("br", null),
            React.createElement("div", null,
                React.createElement(Typography.Text, { type: "secondary", className: "label-2", strong: true }, LabelConfigs.CUSTOMIZE_COLUMNS.toUpperCase())),
            shouldFixFirstColumn &&
                React.createElement("div", { className: "margin-top-xs" },
                    React.createElement(Checkbox, { disabled: true, className: "pre-checked", checked: true }),
                    React.createElement("span", { className: "padding-left-xs" }),
                    orderedColumns[0].title),
            React.createElement(DragDropContext, { onDragEnd: onDragEnd },
                React.createElement(Droppable, { droppableId: "droppable" }, function (provided, snapshot) { return (React.createElement("div", { ref: provided.innerRef },
                    newOrderedColumns.filter(function (column) { return column.key !== "tableSettings"; }).map(function (column, index) {
                        return React.createElement(Draggable, { key: column.key, draggableId: column.key.toString(), index: index }, function (provided, snapshot) {
                            var innerRef = provided.innerRef, draggableProps = provided.draggableProps, dragHandleProps = provided.dragHandleProps;
                            var isDragging = snapshot.isDragging;
                            var isFixedColumn = fixedColumns.includes(column.key.toString());
                            return (React.createElement("div", __assign({ ref: innerRef }, draggableProps, dragHandleProps, { className: "margin-xs-vertical", style: __assign(__assign({}, draggableProps.style), { background: isDragging ? "background-color-blue-2" : "inherit", cursor: !isDragging ? "move" : "inherit" }) }),
                                React.createElement(Checkbox, { disabled: isFixedColumn, className: isFixedColumn ? "pre-checked" : "", onChange: function () { return onToggleColumn(column.key.toString()); }, checked: newSelectedColumnKeys.includes(column.key.toString()) || isFixedColumn }),
                                React.createElement("span", { className: "padding-left-xs" }),
                                column.title,
                                React.createElement("span", { className: "padding-right-xs" }),
                                React.createElement(Icon, { style: { float: "right", lineHeight: "inherit" }, component: function () { return React.createElement(FontAwesomeIcon, { icon: faBars }); } })));
                        });
                    }),
                    provided.placeholder)); }))),
        React.createElement(Divider, { className: "no-margin" }),
        React.createElement("div", { className: "padding-sm", style: { textAlign: "right", backgroundColor: ColorConfigs.gray1 } },
            defaultColumnKeys &&
                React.createElement(React.Fragment, null,
                    React.createElement(Button, { type: "link", onClick: function () { return onRevert(); } },
                        React.createElement(FontAwesomeIcon, { icon: faUndo, style: { fontSize: '16px' } }),
                        React.createElement("span", { className: "margin-left-xs" }),
                        React.createElement("b", null, "Reset")),
                    React.createElement("span", { className: "margin-left-xs" })),
            React.createElement(Button, { type: "primary", onClick: function () {
                    if (shouldFixFirstColumn) {
                        var newNewOrderColumns = __spreadArray([], newOrderedColumns, true);
                        newNewOrderColumns.unshift(orderedColumns[0]);
                        onChange(newNewOrderColumns, newSelectedColumnKeys, newSize);
                    }
                    else {
                        onChange(newOrderedColumns, newSelectedColumnKeys, newSize);
                    }
                } }, "Customize"))));
};
export default ColumnSetting;
//# sourceMappingURL=column-setting.js.map